export const alert_style = {       
    // baseStyle: ({status}) => ({                          
    //             bg: status == 'warning' ? 'red.300' : 'red.500',                
    //             // defaultProps:{
    //             //     status: 'info'
    //             // }
    //         })
}